import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import http from "../lib/http";

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

const handleLogin = async (e) => {
  e.preventDefault();
  try {
    const res = await http.post('/api/auth/login', { email, password });
    localStorage.setItem('user', JSON.stringify(res.data));
    
    const role = res.data.user.role;
    if (role === 'admin') navigate('/admin');
    else navigate('/');
  } catch (err) {
    setError('Invalid email or password');
  }
};

  return (
    <div className="container mt-5" style={{ maxWidth: '400px' }}>
      <h3 className="text-center mb-4">Login</h3>
      {error && <div className="alert alert-danger">{error}</div>}
      <form onSubmit={handleLogin}>
        <div className="mb-3">
          <label>Email</label>
          <input type="email" className="form-control" value={email} onChange={(e) => setEmail(e.target.value)} required />
        </div>
        <div className="mb-3">
          <label>Password</label>
          <input type="password" className="form-control" value={password} onChange={(e) => setPassword(e.target.value)} required />
        </div>
        <button className="btn btn-primary w-100">Login</button>
      </form>
      <div className="text-center mt-3">
        <p>Don't have an account? <Link to="/signup">Register here</Link></p>
      </div>
    </div>
  );
}
